module.exports = __webpack_public_path__ + "img/i-3.399bd65a.svg";